import Axios from "@app/api/axios";

const editComment = (payload) => Axios.put(`comments/${payload.id}`, payload);

export default editComment;
